const tripSwiper = new Swiper('.trip-slider', {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 30,
    centeredSlidesBounds: true,

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // Responsive breakpoints
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: false,
        },

        350: {
            slidesPerView: 1.1,
            spaceBetween: 10,
            centeredSlides: false,
        },

        380: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            centeredSlides: false,
        },


        576: {
            slidesPerView: 1.5,
            spaceBetween: 10,
            centeredSlides: false,
        },


        730: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: false,
        },

        850: {
            slidesPerView: 2.3,
            spaceBetween: 20,
            centeredSlides: false,
        },


        1280: {
            slidesPerView: 3,
            spaceBetween: 30
        }
    }
});


const dealSwiper = new Swiper('.deal-slider', {
    loop: true,
    slidesPerView: 4.25,
    spaceBetween: 30,
    centeredSlides: true,

    // Responsive breakpoints
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: false,
        },

        350: {
            slidesPerView: 1.1,
            spaceBetween: 10,
            centeredSlides: false,
        },

        380: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            centeredSlides: false,
        },

        576: {
            slidesPerView: 1.5,
            spaceBetween: 10,
            centeredSlides: false,
        },

        768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
            centeredSlides: false,
        },

        900: {
            slidesPerView: 2.5,
            spaceBetween: 20,
            centeredSlides: false,
        },

        1100: {
            slidesPerView: 3.1,
            spaceBetween: 20,
        },

        1250: {
            slidesPerView: 3.5,
            spaceBetween: 30,
        },

        1450: {
            sliderPerView: 4.25,
            spaceBetween: 30,
        },
    }
});
